// src/utils/language.js
// تغيير لغة الواجهة من أي مكان (شاشة الدخول، القائمة العلوية...) مع حفظها وضبط اتجاه الصفحة
import i18n from "i18next";

export const LANGUAGES = [
  { code: "ar", label: "العربية", short: "ع", dir: "rtl" },
  { code: "en", label: "English", short: "EN", dir: "ltr" },
];

const STORAGE_KEY = "lang";

export const getSavedLanguage = () => {
  try { return localStorage.getItem(STORAGE_KEY) || localStorage.getItem("i18nextLng") || "ar"; }
  catch { return "ar"; }
};

/** يضبط dir و lang على <html> حتى تنعكس الصفحة كاملة (وليس المكوّن فقط) */
export const applyDocumentDirection = (lng) => {
  const dir = LANGUAGES.find(l => l.code === lng)?.dir || (lng?.startsWith("ar") ? "rtl" : "ltr");
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);
  document.body?.setAttribute("dir", dir);
  return dir;
};

export async function setLanguage(lng) {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
    localStorage.setItem("i18nextLng", lng);
  } catch { /* وضع التصفح الخاص */ }
  applyDocumentDirection(lng);
  await i18n.changeLanguage(lng);
}

// عند كل تغيير لغة (من أي مكان) يُضبط الاتجاه تلقائيًا
i18n.on?.("languageChanged", applyDocumentDirection);
